import React from 'react'

const Client = () => {
    return (
        <>
            {/* <!--====== CLIENT LOGO PART START ======--> */}
            <section>
                <div className="container-fluid bg-light mb-5">

                    <div className="client-logo-area client-logo-one">
                        {/* <!--======  Start Section Title Two ======--> */}
                        <div className="section-title-two"> 
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="content">

                                            <h2 className="fw-bold" data-aos="fade-up">Ils nous font confiance. Pourquoi pas vous ?</h2>
                                            <p data-aos="fade-down">
                                                Suivez l'évolution technologique et faites passer votre activité au niveau supérieur.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- container --> */}
                        </div>
                        {/* <!--====== End Section Title Two ======--> */}
                        <div className="container logo-client">
                            <div className="row " data-aos="fade-right">
                                <div className="col-md-3 col-6">
                                    <div className="single-client text-center">
                                        <img src="https://cdn.ayroui.com/1.0/images/client-logo/graygrids.svg" alt="Logo" />
                                    </div>
                                    {/* <!-- single client --> */}
                                </div>
                                <div className="col-md-3 col-6" >
                                    <div className="single-client text-center">
                                        <img src="https://cdn.ayroui.com/1.0/images/client-logo/uideck.svg" alt="Logo" />
                                    </div>
                                    {/* <!-- single client --> */}
                                </div>
                                <div className="col-md-3 col-6">
                                    <div className="single-client text-center" >
                                        <img src="https://cdn.ayroui.com/1.0/images/client-logo/ayroui.svg" alt="Logo" />
                                    </div>
                                    {/* <!-- single client --> */}
                                </div>
                                <div className="col-md-3 col-6" >
                                    <div className="single-client text-center" >
                                        <img src="https://cdn.ayroui.com/1.0/images/client-logo/lineicons.svg" alt="Logo" />
                                    </div>
                                    {/* <!-- single client --> */}
                                </div>
                            </div>
                            {/* <!-- row --> */}
                        </div>
                        {/* <!-- container --> */}
                    </div>
                </div>
                {/* <!--====== CLIENT LOGO PART ENDS ======--> */}
            </section>
        </>
    )
}

export default Client